import { useQuery } from '@tanstack/react-query';
import { fetchAppInstallUrl } from '../services/fetchAppInstallUrl';
import { useStoreData } from '../hooks/useStoreData';
import { StoreIdRequiredError } from '../errors/storeIdRequired';

export const useFetchInstallAppUrl = () => {
    const { storeData } = useStoreData();

    const storeId = storeData?.id;

    return useQuery({
        queryKey: ['installAppUrl', storeId],
        queryFn: () => {
            if (!storeId) {
                throw new StoreIdRequiredError();
            }

            return fetchAppInstallUrl(storeId);
        },
        enabled: !!storeId,
        retry: 2,
    });
};
